import React from "react";
import Axios from "axios";
import { useEffect, useState } from "react";
import Navigation from "../components/Navigation/Navigation";
import "bootstrap/dist/css/bootstrap.min.css";
import { Container } from "react-bootstrap";

function AppCat() {
	const [catFact, setCatFact] = useState("");

	const fetchCatFact = () => {
		Axios.get("https://catfact.ninja/fact?max_length=150").then((respons) => {
			setCatFact(respons.data.fact);
		});
	};
	useEffect(() => {
		Axios.get("https://catfact.ninja/fact").then((respons) => {
			setCatFact(respons.data.fact);
		});
	}, []);

	return (
		<>
			{/* Navigeringsmeny inlänkad */}
			<Navigation />
			<div className="main">
				<section className="wrapper">
					{/* Applikationens innehåll börjar */}
					<h1>Kattfakta</h1>
					<div className="wrapper_kattfakta">
						<h3>Kort fakta om katter</h3>
						<p>
							Varje gång du klickar på knappen kommer du att på engelska få se ny spännade
							fakta om katter!
						</p>
						{/* Vid knapptryck hämtas ny kattfakta (jsondata) från ett externt API */}
						<button className="button1 center" onClick={fetchCatFact}>
							Klicka för kattfakta
						</button>
						<div className="wrapper_kattfakta faktaruta">
							{/* Kattfakta (jsondata) länkas in */}
							<p>{catFact}</p>
							{/* Gif-bild */}
							<img
								src="./bilder/glad_katt.gif"
								alt="Katt som ger ut kärlek"
								className="center"
							/>
						</div>
					</div>
					{/* Embeded YouTube-videos på sidan */}
					<Container>
						<h3>Lite inspirerande fakta från YouTube:</h3>
						<div className="ratio ratio-16x9 kattvideo">
							<iframe
								src="https://www.youtube.com/embed/akiN09M2HwY?si=gfSoQeCQeXHNH31Z"
								title="YouTube video"
								allowFullScreen
							></iframe>
						</div>
						<div className="ratio ratio-16x9 kattvideo">
							<iframe
								src="https://www.youtube.com/embed/HyQGpaTcJmU?si=VNFTlkaO6Zuk-AaM"
								title="YouTube video"
								allowFullScreen
							></iframe>
						</div>
					</Container>
				</section>
			</div>
		</>
	);
}

export default AppCat;
